import React, { useEffect } from "react";
import ReactFlow, { Controls, useNodesState } from "reactflow";
import { Button } from "@mui/material";
import { SensorNode, LayoutNode } from "./CustomNode";
import "reactflow/dist/style.css";
import "./overview.css";

const nodeTypes = {
  pinSensor: SensorNode,
  sensorLayout: LayoutNode,
};

const LayoutCanvas = ({
  id,
  layout,
  elements,
  isDraggable,
  callbackNewPosition,
}) => {
  const [nodes, setNodes, onNodesChange] = useNodesState([]);

  // console.log("layout", layout);

  useEffect(() => {
    if (elements.length > 0) {
      // console.log("elements", elements);
      let tempElements = [];
      tempElements.push({
        id: "layout",
        type: "sensorLayout",
        position: { x: 50, y: 0 },
        data: {
          url: layout,
        },
        style: {
          display: "flex",
          // width: "100%",
          alignItems: "center",
          justifyContent: "center",
        },
      });

      let begin = true;
      let multiply = false;
      let counter = 1;
      let offsetXValue = 50;
      const style = {
        width: "fit-content",
        backgroundColor: "transparent",
        borderRadius: "50%",
      };
      elements.map((item, index) => {
        if (item.position.x === 0 && item.position.y === 0) {
          tempElements.push({
            ...item,
            data: {
              ...item.data,
              sensorDetail: { ...item.sensorDetail },
            },
            position: {
              ...item.position,
              x: begin ? 0 : multiply ? offsetXValue * counter : offsetXValue,
              y: -100,
            },
            style,
          });
          if (begin) {
            begin = false;
            multiply = false;
          } else {
            multiply = true;
            counter = counter + 1;
          }
        } else {
          tempElements.push({
            ...item,
            data: {
              ...item.data,
              sensorDetail: { ...item.sensorDetail },
            },
            style,
          });
        }
      });

      // console.log(tempElements);
      setNodes(tempElements);
    }
  }, [elements]);

  const onInit = (reactFlowInstance) => {
    // console.log("flow loaded:", reactFlowInstance);
    reactFlowInstance.fitView();
  };

  return (
    <div style={{ width: "100%", height: "500px", position: "relative" }}>
      <ReactFlow
        nodes={nodes}
        onNodesChange={onNodesChange}
        onInit={onInit}
        fitView
        attributionPosition="bottom-right"
        nodeTypes={nodeTypes}
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        nodesDraggable={isDraggable}
      >
        <Controls />
      </ReactFlow>
      {isDraggable && (
        <div
          style={{
            position: "absolute",
            top: "0",
            right: "0",
            margin: "1em",
          }}
        >
          <Button
            style={{
              backgroundColor: "#33b5e5",
              color: "#fff",
              fontSize: "1rem",
              outline: "none",
              border: "none",
              borderRadius: "0.2em",
              padding: "0.3em 0.5em",
            }}
            onClick={() => callbackNewPosition(nodes, id)}
          >
            Simpan
          </Button>
        </div>
      )}
    </div>
  );
};

export default LayoutCanvas;
